import { createPortal } from "react-dom";

import FnrErrorBoundary from "UI/FnrErrorBoundary";

function Portal({ children, to }) {
  if (!to) return children;

  return createPortal(
    <FnrErrorBoundary boundaryName="Portal">{children}</FnrErrorBoundary>,
    to
  );
}

export default Portal;
